import { CDN_URL_ICONS, CDN_URL_IMAGES } from '@/configs';
import s from './style.module.scss';
import { ColumnContent } from '../ColumnContent';
import { ROUTE_PATH } from '@/constants/route-path';

export const Section2 = (): JSX.Element => {
  return (
    <div className={`${s.container}`}>
      <p className={s.title}>Bitcoin, reimagined.</p>
      <p className={s.desc}>
        New Bitcoin City is a radically new way to explore Bitcoin - beyond just
        a currency.
      </p>

      <div className={s.grid}>
        <ColumnContent
          id="DeFi"
          heading="DeFi"
          subTitle="Explore Trustless Computer protocol that allow users to engage in DeFi activities,  other financial instruments on Bitcoin."
          imgUrl={`${CDN_URL_IMAGES}/home_03c.png`}
          link={`${ROUTE_PATH.DEFI}`}
          titleLink="Trade"
        />
        <ColumnContent
          id="NFTs"
          heading="NFTs"
          subTitle="Go into a world of art, smart inscriptions, and BRC-721 tokens on Bitcoin."
          imgUrl={`${CDN_URL_IMAGES}/home_02c.png`}
          link={`${ROUTE_PATH.NFTS}`}
          titleLink="Collect"
        />
      </div>
    </div>
  );
};
